import { makeStyles } from '@material-ui/core';
import themes from 'styles/themes';

export const useStyles = makeStyles((theme) => {
    return {
        quizRowContainer: {
            display: 'flex',
            flexDirection: 'row',
            marginTop: 'auto',
            marginBottom: 'auto',
            alignSelf: 'center',
        },
        quizRow: {
            width: '100%',
            margin: 0,
            gap: 0,
        },
        quizItem: {
            borderRadius: 10,
            padding: 32,
            width: 124,
            height: 155,
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
        },
        buttonContinue: {
            color: 'white',
            textDecoration: 'none',
            textTransform: 'none',
        },
        wrapperItem: {},
        itemTitle: {
            fontSize: 14,
            marginTop: 10,
            fontWeight: 500,
            marginBottom: 0,
        },
        itemSubTitle: {
            margin: 0,
            padding: 0,
            fontSize: 16,
            color: theme.palette.grey[300],
            letterSpacing: -0.5,
        },
        button: {
            maxWidth: 330,
            width: '100%',
            height: 44,
            padding: 0,
            fontSize: 14,
            fontWeight: 600,
            fontFamily: 'PoppinsRegular',
            background: themes.palette.primary.main,
            borderRadius: '29px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textTransform: 'uppercase',
            border: 'none',
            color: themes.palette.common.white,
            alignSelf: 'center',
        },
        hijabImg: {
            marginTop: 'auto',
            marginBottom: 'auto',
        },
    };
});
